import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import './CancelSubscriptionModal.css';

interface CancelSubscriptionModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const CancelSubscriptionModal: React.FC<CancelSubscriptionModalProps> = ({
  show,
  onHide,
  onConfirm,
  loading,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="cancel-subscription-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <ExclamationTriangleFill className="warning-icon" />
          <span>Are you sure?</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you would like to cancel your account?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="link"
          onClick={onHide}
          className="cancel-btn"
          disabled={loading}
        >
          CANCEL
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          className="action-btn"
          disabled={loading}
        >
          {loading ? <Spinner size="sm" /> : 'Confirm'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelSubscriptionModal;
